import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generatePassword(length = 8) {
  // function generate a password with given length, it has special characters and numbers
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=";
  const password = Array.from(
    { length },
    () => characters[Math.floor(Math.random() * characters.length)],
  ).join("");
  return password;
}

export function getRandomHexColor() {
  // Generate a random number between 0 and 16777215 (0xFFFFFF in decimal)
  const randomColor = Math.floor(Math.random() * 16777215).toString(16);

  // Pad with zeros if the result is less than 6 characters
  return `#${randomColor.padStart(6, "0")}`;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}

export function toSnakeCase(str: string) {
  return str
    .normalize("NFKD") // normalize accents
    .replace(/[^\w\s-]/g, "") // remove non-word chars
    .trim()
    .replace(/[\s-]+/g, "_") // spaces & dashes → underscore
    .toLowerCase();
}
